import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { FamilyMemberForm } from 'theSource/features/FamilyMembers/components';
import {
  GET_DEPENDENTS_QUERY_KEY,
  stripErrorMessage,
} from 'theSource/features/FamilyMembers/utils';
import {
  ErrorResponseDto,
  FormFieldsCategory,
  FormValues,
  FormValuesDto,
  ResponseDto,
} from 'theSource/types';
import { mapFormValues, useApiMutation } from 'theSource/utils';
import { EDIT_DEPENDENT_QUERY_KEY } from './utils';
import { DependentDto } from 'theSource/features/FamilyMembers/types';
import { ResetFormHandler } from 'theSource/components';
import { ROUTES } from 'theSource/app/routes';
import { selectEnrollmentContext } from 'theSource/features/Home/components/EnrollmentBanner/services';

interface FamilyMemberEditFormProps {
  categories: FormFieldsCategory[];
  dependentInfo: DependentDto;
}

export const FamilyMemberEditForm = ({
  categories,
  dependentInfo,
}: FamilyMemberEditFormProps) => {
  const { dependentId } = useParams();
  const navigate = useNavigate();

  const enrollmentContextType = useSelector(selectEnrollmentContext);

  const { isLoading: isSaving, mutate } = useApiMutation<
    ResponseDto,
    ErrorResponseDto,
    FormValuesDto
  >({
    queryKey: EDIT_DEPENDENT_QUERY_KEY,
    queryKeysToInvalidate: `${GET_DEPENDENTS_QUERY_KEY}-${enrollmentContextType}`,
    invalidateQueriesCallback: () => navigateBack(),
    method: 'put',
    endpoint: `/dependents/${dependentId}`,
    getErrorMessage: (error) =>
      stripErrorMessage(error.response?.data?.details),
  });

  const navigateBack = () => navigate(ROUTES.additional.profile.myFamily.path);

  const handleSubmit = (values: FormValues, resetForm: ResetFormHandler) =>
    mutate(mapFormValues(categories, values), {
      onSuccess: () => resetForm(),
    });

  const handleCancelClick = () => navigateBack();

  return (
    <FamilyMemberForm
      categories={categories}
      isLoading={isSaving}
      onSubmitClick={handleSubmit}
      onCancelClick={handleCancelClick}
      values={dependentInfo}
    />
  );
};
